export class ExpenseHead {
    constructor(
        public id?: number,
        public name?: string,
        public description?: string,
        public accountHeadId?: string,
        public incomeAccountHeadId?: string,
        // public isNadavaravu?: boolean,
        // public isSaleable?: boolean,
        // public isSamarpanam?: boolean,
        public unitId?: number,
        // public openingStock?: number,
        // public openingDate?: string,
        public isStockUpdate?: boolean,
        public showStockOption?: boolean,
        public quantity?: number,
        public productId?: number,
        public rate?: number,
        public category?: number[],
        public storeId?: number,
        public outOfStockLimit?: number,
        public isCostChanging?: boolean
    ) { }
}

export class Material {
    constructor(
        public id?: number,
        public name?: string,
        public description?: string,
        public accountHeadId?: string,  
        public incomeAccountHeadId?: number,      
        public unitId?: number,        
        public isStockUpdate?: boolean,
        public showStockOption?: boolean,
        public quantity?: number,
        public productId?: number,
        public rate?: number,
        public category?: number[],
        public storeId?: number,
        public outOfStockLimit?: number
    ) { }
}
export class ViewTempleMaterial {
    constructor(
        public productId?: number,
        public name?: string,
        public description?: string,
        public isNadavaravu?: boolean,
        public isSaleable?: boolean,
        public isMetal?: boolean,
        public isSamarpanam?: boolean,
        public accountHeadId?: number,
        public accountHeadName?: string,
        public incomeAccountHeadId?: number,
        public incomeAccountHeadName?: string,
        public showStockOption?: boolean,
        public unitId?: number,
        public unitName?: string,
        public rate?: number,
        public quantity?: number,
        public storeId?: number,
        public outOfStockLimit?: number,
        public addedQty?: number,
        public isCostChanging?: boolean
    ) { }
}
